import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice.js';
import alertsReducer from './slices/alertsSlice.js';
import themeReducer from './slices/themeSlice.js';
import dashboardReducer from './slices/dashboardSlice.js';
import graphReducer from './slices/graphSlice.js';
import entityReducer from './slices/entitySlice.js';
import graphQueryReducer from './slices/graphQuerySlice.js';
import ruleReducer from './slices/ruleSlice.js';
import mlReducer from './slices/mlSlice.js';
import gapAnalysisReducer from '../features/gap-analysis/store/gapAnalysisSlice.js';
import agentRegistryReducer from '../features/agent-registry/store/agentRegistrySlice.js';
import aiGovernanceReducer from '../features/ai-governance/store/aiGovernanceSlice.js';
// APB-1600: BRAIN Assistant conversation state
import assistantReducer from './slices/assistantSlice.js';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    alerts: alertsReducer,
    theme: themeReducer,
    dashboard: dashboardReducer,
    graph: graphReducer,
    entity: entityReducer,
    graphQuery: graphQueryReducer,
    rules: ruleReducer,
    ml: mlReducer,
    gapAnalysis: gapAnalysisReducer,
    agentRegistry: agentRegistryReducer,
    aiGovernance: aiGovernanceReducer,
    // APB-1600
    assistant: assistantReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
